<template>
    <div class="favorite">
        <router-link :to="{ name: route }">
            <mu-flex justify-content="start" align-items="center">
                <img :src="icon" :alt="title" width="30px" v-if="icon">
                <font-awesome-icon icon="star" v-if="!icon" />
                <p v-html="title"></p>
            </mu-flex>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'favorite',
        props: ['favorite'],

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Título do favotiro
             */
            title () {
                return this.favorite ? this.favorite.title : '&nbsp;'
            },

            /**
             * Atalho do favorito
             */
            icon () {
                return this.favorite ? this.favorite.icon : null
            },

            /**
             * Rota do favorito
             */
            route () {
                return this.favorite ? this.favorite.route : 'app.profile'
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../assets/stylus/bootstrap.styl'

    .favorite

        background lighten($grey, 80%)
        border-radius 5px
        border 1px lighten($grey, 40%) dotted
        margin 5px
        padding 5px 10px
        transition background 0.4s
        &:hover
            background lighten($grey, 70%)
        a
            color inherit
        img
            margin-right 10px
        i
            opacity 0.4
            margin auto

</style>
